import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import { initializeState, reportCleared } from "../../../store/sdlcReportSlice";
import { initFilter, initSort } from "../dependencies/utils";
import { resetAllSlices, restoreState } from "./utils";
export const initialState = {
    filter: initFilter,
    sort: initSort,
    pagination: { itemsPerPage: 10, currentPage: 1 },
    filteredByLink: false,
};
const dependenciesSlice = createSlice({
    name: "fileBrowserDependencies",
    initialState: initialState,
    reducers: {
        filterUpdated: (state, action) => {
            state.filter = cloneDeep(action.payload);
            state.filteredByLink = false;
            state.filter.dependencyId = null;
            state.pagination.currentPage = 1;
        },
        filterByDependencyId: (state, action) => {
            state.filter = cloneDeep(initFilter);
            state.filter.dependencyId = action.payload.id;
            state.filter.dependencyName = action.payload.name;
            state.filteredByLink = true;
            state.pagination.currentPage = 1;
        },
        filterByLicenseFamily: (state, action) => {
            state.filter = cloneDeep(initFilter);
            state.filter.license = action.payload;
            state.filter.dependencyId = null;
            state.filteredByLink = true;
            state.pagination.currentPage = 1;
        },
        filterByMalicious: (state, action) => {
            state.filter = cloneDeep(initFilter);
            state.filter.maliciousOnly = action.payload;
            state.filter.dependencyId = null;
            state.filteredByLink = true;
            state.pagination.currentPage = 1;
        },
        filterByLinkingType: (state, action) => {
            state.filter = cloneDeep(initFilter);
            state.filter.linking = action.payload;
            state.filter.dependencyId = null;
            state.filteredByLink = true;
            state.pagination.currentPage = 1;
        },
        filterByLinkingTypeAndLicenseFamily: (state, action) => {
            state.filter = cloneDeep(initFilter);
            state.filter.linking = action.payload.linkingType;
            state.filter.license = action.payload.licenseFamily;
            state.filter.dependencyId = null;
            state.filteredByLink = true;
            state.pagination.currentPage = 1;
        },
        sortUpdated: (state, action) => {
            state.sort = action.payload;
            state.pagination.currentPage = 1;
        },
        paginationUpdated: (state, action) => {
            state.pagination = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(initializeState, (state, action) => {
            return restoreState(state, action.payload, "dependencies");
        });
        builder.addCase(reportCleared, () => {
            return cloneDeep(initialState);
        });
        builder.addCase(resetAllSlices, () => {
            return cloneDeep(initialState);
        });
    },
});
export const dependenciesReducer = dependenciesSlice.reducer;
export const { filterUpdated, filterByDependencyId, filterByLicenseFamily, filterByLinkingType, filterByLinkingTypeAndLicenseFamily, filterByMalicious, paginationUpdated, sortUpdated, } = dependenciesSlice.actions;
export const selectFilter = (state) => state.report.fileBrowser.dependencies.filter;
export const selectSort = (state) => state.report.fileBrowser.dependencies.sort;
export const selectPagination = (state) => state.report.fileBrowser.dependencies.pagination;
export const selectFilteredByLink = (state) => state.report.fileBrowser.dependencies.filteredByLink;
//# sourceMappingURL=dependenciesSlice.js.map